import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { chatReducer } from "./chatReducer";
import { vitalMonitoringReducer } from "./vitalMonitoringsReducer";

export const rootReducer = combineReducers({
  users: userReducer,
  chat: chatReducer,
  vitals: vitalMonitoringReducer
});